<template>
    <vf-button
        :size="size"
        v-bind="$attrs"
        v-on="$listeners"
        class="vf-loader-button"
    >
        <span
            class="vf-loader-button__content"
            :class="{
                'vf-loader-button__content--hidden': status !== STATUSES.NONE
            }"
        >
            <slot />
        </span>
        <transition name="fade">
            <span
                class="vf-loader-button__icon-wrapper"
                v-if="status !== STATUSES.NONE"
            >
                <spinning-loader
                    v-if="status === STATUSES.PENDING"
                    :size="iconSize"
                />
                <vf-checkmark-icon
                    v-else-if="status === STATUSES.SUCCESS"
                    :size="iconSize"
                />
                <vf-exclamation-mark-icon
                    v-else-if="status === STATUSES.ERROR"
                    circle="outline"
                    :size="iconSize"
                />
            </span>
        </transition>
    </vf-button>
</template>

<script>
import { SIZES } from 'design-assets/constants/sizes.js';
import { LOADER_STATUSES as STATUSES } from 'commons/constants/status.js';
import vfButton from './vf-button.vue';
import spinningLoader from '../inline_loader/spinning-loader.vue';
import { vfCheckmarkIcon } from '../svg/icons/checkmark_icon.c.js';
import { vfExclamationMarkIcon } from '../svg/icons/exclamation_mark.c.js';

const ICON_SIZE_BY_BUTTON_SIZE = {
    [SIZES.INLINE]: SIZES.SMALL,
    [SIZES.TINY]: SIZES.SMALL,
    [SIZES.SMALL]: SIZES.SMALL,
    [SIZES.MEDIUM]: SIZES.MEDIUM,
    [SIZES.LARGE]: SIZES.MEDIUM,
};

export default {
    props: {
        status: {
            type: String,
            validator: (val) => Object.values(STATUSES).includes(val),
            required: true,
        },
        size: String,
    },
    beforeCreate() {
        this.STATUSES = STATUSES;
    },
    computed: {
        iconSize() {
            return ICON_SIZE_BY_BUTTON_SIZE[this.size];
        },
    },
    components: {
        vfButton,
        spinningLoader,
        vfCheckmarkIcon,
        vfExclamationMarkIcon,
    },
};
</script>

<style lang="scss" scoped>
@import '../../../css/variables/module';

.vf-loader-button {
    position: relative;
    color: currentcolor;
}

.vf-loader-button__content {
    opacity: 1;
    transition: opacity map-get($transitions, 'super-fast');
}

.vf-loader-button__content--hidden {
    opacity: 0;
}

.vf-loader-button__icon-wrapper {
    position: absolute;
    /* stylelint-disable declaration-block-no-redundant-longhand-properties */
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /* stylelint-enable declaration-block-no-redundant-longhand-properties */
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
